<template>
    <div class="default-layout">
        <div class="container-fluid">
            <site-header/>

            <div class="row justify-content-center" id="layout-content">
                <div class="col-12">
                    <slot />
                </div>
            </div>

            <site-footer/>
        </div>
    </div>
</template>

<script>
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default {
    name: 'DefaultLayout',
    components: {
        SiteFooter,
        SiteHeader,
    }
};
</script>


<style scoped>
#layout-content {
    margin-bottom: 150px;
}
</style>
